import { TChatOptions } from '_types/options';

export const DEFAULT_LANG = 'fr';

const getScriptElement = (): HTMLScriptElement | null => {
  const current = document.currentScript;

  if (current instanceof HTMLScriptElement) return current;

  return document.querySelector<HTMLScriptElement>('script[data-api-key]');
};

export const getChatOptions = (): null | TChatOptions => {
  const script = getScriptElement();
  const apiKey = script?.dataset.apiKey?.trim();
  const apiUrl = script?.dataset.apiUrl?.trim();

  if (!script || !apiKey || !apiUrl) return null;

  const zIndex = Number(script.dataset.zIndex);

  return {
    apiKey,
    apiUrl: apiUrl.replace(/\/?$/, '/'),
    lang: script.dataset.lang?.trim() || DEFAULT_LANG,
    name: script.dataset.name?.trim() || undefined,
    zIndex: Number.isFinite(zIndex) && zIndex > 0 ? zIndex : undefined,
  };
};
